// w17.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W17 = () => {
  return <WW config={pageConfigs.w17} />;
};

export default W17;
